// https://testepay.homebank.kz/api/news/merchant?filter=all
import { Content, del, get, post, put } from '~/utils/ajax'

export const getNewsData = async (type: string, size: number, page: number) => get<any>(`news/merchant?filter=${type}&size=${size}&page=${page}`)

export const getNews = async (id: string) => get<any>(`news/${id}`)